import script from "./PumpProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./PumpProgram.vue?vue&type=script&setup=true&lang=js"

import "./PumpProgram.vue?vue&type=style&index=0&id=0975c3f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0975c3f9"]])

export default __exports__